module.exports = __webpack_public_path__ + "static/media/langganan.4bd270df.svg";